import React from 'react'
import type { Summary } from 'types/summary'
import Tag from 'components/ui/tag'
import styles from './index.module.css'

type Props = {
  summary: Summary & {
    coupon_code: string | null | undefined
  }
  onRemoveCoupon: (...args: Array<any>) => any
}

const Discounts = ({
  summary,
  onRemoveCoupon,
}: Props): null | React.ReactElement<'div'> => {
  if (
    !Boolean(summary.total_discount_in_cents) &&
    !Boolean(summary.total_tax_in_cents) &&
    !Boolean(summary.coupon_code)
  ) {
    return null
  }

  const currencySymbol = '$'
  return (
    <div className={styles.discounts}>
      {!Boolean(summary.total_discount_in_cents) ? null : (
        <>
          <div className={styles.discountsLabelContainer}>
            <span>Subtotal:</span>
            <span className={styles.discountsPrice}>
              {currencySymbol}
              {summary.subtotal_in_cents / 100}
            </span>
          </div>
          <div className={styles.discountsLabelContainer}>
            <span>Discount:</span>
            <span className={styles.discountsPrice}>
              -{currencySymbol}
              {summary.total_discount_in_cents / 100}
            </span>
          </div>
        </>
      )}
      {!Boolean(summary.total_tax_in_cents) ? null : (
        <div className={styles.discountsLabelContainer}>
          <span>Sales tax:</span>
          <span className={styles.discountsPrice}>
            {currencySymbol}
            {summary.total_tax_in_cents / 100}
          </span>
        </div>
      )}
      {!Boolean(summary.coupon_code) ? null : (
        <Tag tag={summary.coupon_code || ''} onRemoveClick={onRemoveCoupon} />
      )}
    </div>
  )
}

export default Discounts
